module.exports = __webpack_public_path__ + "static/media/13ITC1.a832eaca.jpg";